import { getI18ns } from 'components/hoc/index';
import { Section } from 'components/ui/index';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { compose } from 'redux';
import { ReportTableSetup } from 'views/index';

const propTypes = {
};

class TableSetupSection extends PureComponent {
  render() {
    const { i18ns } = this.props;
    const { title } = i18ns;

    return (
      <Section title={title}>
        <ReportTableSetup />
      </Section>
    );
  }
}

TableSetupSection.propTypes = propTypes;
const enhancers = compose(
  getI18ns({
    title: 'page.ReportFilters.sectionNames.display',
  }),
);

export default enhancers(TableSetupSection);



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/TableSetupSection.jsx